var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('video-player',{ref:"videoPlayers",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"loadeddata":_vm.onLoadedData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }